import { ActionType } from 'typesafe-actions';

import * as actions from '../actions/ChangeKnoInMeasureActions';
import { ChangeKnoInMeasureActionsEnum } from '../enums/ChangeKnoInMeasureActionsEnum';
import { IKnoOrganisationChild } from '../../APIPackage/CatalogsModule/interfaces/IKnoOrganisationChild';
import { IMeasureKnoChangeHistoryItem } from '../../APIPackage/KnmModule/interfaces/IMeasureKnoChangeHistoryItem';
import { IMeasureNumberSearchItem } from '../../APIPackage/KnmModule/interfaces/IMeasureNumberSearchItem';

export type ChangeKnoInMeasureAction = ActionType<typeof actions>;

export interface IChangeKnoInMeasureState {
  ervkKnoOrganisationSearchQuery: string | null;
  ervkKnoOrganisations: IKnoOrganisationChild[];
  measureNumbersSearchQuery: string | null;
  measureNumbers: IMeasureNumberSearchItem[];
  historyChangesItems: IMeasureKnoChangeHistoryItem[];
}

const initialState: IChangeKnoInMeasureState = {
  ervkKnoOrganisationSearchQuery: null,
  ervkKnoOrganisations: [],
  measureNumbersSearchQuery: null,
  measureNumbers: [],
  historyChangesItems: [],
};

export function changeKnoInMeasureReducer(
  state: IChangeKnoInMeasureState = initialState,
  action: ChangeKnoInMeasureAction,
) {
  switch (action.type) {
    case ChangeKnoInMeasureActionsEnum.CHANGE_KNO_ERVK_ORGANIZATION_SET: {
      return { ...state, ervkKnoOrganisations: action.payload.knoOrganisations };
    }
    case ChangeKnoInMeasureActionsEnum.CHANGE_KNO_ERVK_ORGANIZATION_SET_SEARCH_QUERY: {
      return { ...state, ervkKnoOrganisationSearchQuery: action.payload.searchQuery };
    }
    case ChangeKnoInMeasureActionsEnum.CHANGE_KNO_MEASURE_NUMBERS_SET: {
      return { ...state, measureNumbers: action.payload.measureNumbers };
    }
    case ChangeKnoInMeasureActionsEnum.CHANGE_KNO_MEASURE_NUMBERS_SET_SEARCH_QUERY: {
      return { ...state, measureNumbersSearchQuery: action.payload.searchQuery };
    }
    case ChangeKnoInMeasureActionsEnum.CHANGE_KNO_MEASURE_HISTORY_CHANGES_SET: {
      return { ...state, historyChangesItems: action.payload.historyItems };
    }
    default:
      return state;
  }
}
